import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MdPeople } from 'react-icons/md';

import { useFormikContext } from 'formik';

import SettingsOption, { OptionType } from '../SettingsOption';
import MaxCapacityModal from './MaxCapacityModal';

const MaxCapacitySettings = () => {
  const { t } = useTranslation(['events']);
  const { values, setFieldValue } = useFormikContext<any>();

  const [showMaxCapacityModal, setShowMaxCapacityModal] = useState(false);

  const toggleMaxCapacityModal = () => {
    setShowMaxCapacityModal((showMaxCapacityModal) => !showMaxCapacityModal);
  };

  const onSave = (maxCapacity: number) => {
    setFieldValue('maxCapacity', maxCapacity);
  };

  return (
    <>
      <SettingsOption
        icon={<MdPeople size={20} />}
        title={t('events:settings.maxCapacity.title')}
        actionLabel={t('events:settings.maxCapacity.actionLabel')}
        value={values?.maxCapacity}
        onClick={toggleMaxCapacityModal}
        tooltipMessage={t('events:settings.maxCapacity.tooltip')}
        type={OptionType.Button}
      />

      {showMaxCapacityModal && (
        <MaxCapacityModal
          onClose={toggleMaxCapacityModal}
          onSave={onSave}
          initialValues={{
            maxCapacity: values?.maxCapacity || ''
          }}
        />
      )}
    </>
  );
};

export default MaxCapacitySettings;
